import { CarDocType } from '@/modules/car/model/car-doc-type';
import { DriverDocType } from '@/modules/driver/model/driver-doc-type';

type TUploadScope = 'myDriver' | 'driver' | 'car';
type TRelatedInfoKind = 'driverLicensing' | 'driverHomeAddress' | 'carLicensing';

interface IRelatedInfoHandle {
  submit: () => Promise<boolean>;
}

interface IRelatedInfoFieldsProps {
  scope: TUploadScope;
}

const DRIVER_RELATED_INFO: Partial<Record<DriverDocType, TRelatedInfoKind>> = {
  pco_paper_license: 'driverLicensing',
  plastic_driving_license: 'driverHomeAddress',
};

const RELATED_INFO_BY_DOC_TYPE: {
  myDriver: Partial<Record<DriverDocType, TRelatedInfoKind>>;
  driver: Partial<Record<DriverDocType, TRelatedInfoKind>>;
  car: Partial<Record<CarDocType, TRelatedInfoKind>>;
} = {
  myDriver: DRIVER_RELATED_INFO,
  driver: DRIVER_RELATED_INFO,
  car: {
    pco_vehicle_certificate: 'carLicensing',
  },
};

export type { TUploadScope, TRelatedInfoKind, IRelatedInfoHandle, IRelatedInfoFieldsProps };
export { RELATED_INFO_BY_DOC_TYPE };
